import * as React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { assignUser } from './view/Actions';
import * as Features from '../../shared/Features';

interface IProps {
    user: any;
    orderId: number;
    actions?: {
        assignUserToOrder: (orderId: number) => void;
    };
}

const AssignUser = (props: IProps) => {
    if (Features.hasFeature(Features.OrderAssignUser, props.user)) {
        return (
            <Button
                data-testid="assign-user-btn"
                bsSize="small"
                title={Translate('view-order/header/assign-user/work')}
                onClick={() => props.actions.assignUserToOrder(props.orderId)}
            >
                <i className="material-icons">person_add</i>
            </Button>
        );
    }
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        actions: {
            assignUserToOrder: (orderId: number) => dispatch(assignUser(orderId))
        }
    };
};

const mapStateToProps = (state: any, ownProps: IProps) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignUser);
